import {actionTypes} from './actionTypes';

export const toggleSubDigitFinishModal=({type_digit})=>{
      return {
            type:actionTypes.TOGGLE_SUB_DIGIT_FINISH,
            payload:{
                  type_digit
            }
      }
}